import React, { useEffect, useState } from 'react';

import SearchIcon from 'Assets/icons/search.svg';

export default function TableSearchInput({ searchValue, handleChange, handleKeyPress, handleEnterPress, handleBlur, placeholder }) {
    const [value, setValue] = useState(searchValue);

    useEffect(() => {
        setValue(searchValue);
    }, [searchValue]);

    const handleInputChange = (e) => {
        setValue(e.target.value);

        if (typeof handleChange === 'function') {
            handleChange(e);
        }
    };

    const handleInputKeyPress = (e) => {
        if (typeof handleKeyPress === 'function') {
            handleKeyPress(e);
        }

        if (e.key === 'Enter' && typeof handleEnterPress === 'function') {
            handleEnterPress(e, value);
        }
    };

    const handleInputBlur = (e) => {
        if (typeof handleBlur === 'function') {
            handleBlur(e, value);
        }
    };

    return (
        <div className="table__search-input__wrapper">
            <div>
                <SearchIcon className="tw-w-2.5 tw-h-2.5" />
            </div>
            <input
                type="text"
                placeholder={placeholder || $t('Search')}
                className="table__search-input tw-bg-transparent"
                value={value}
                onChange={handleInputChange}
                onKeyUp={handleInputKeyPress}
                onBlur={handleInputBlur}
            />
        </div>
    );
}
